import { useState } from "react";
import axios from "axios";
import styles from "./RedeemDiscount.module.css"; // Import CSS module
const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
const RedeemDiscount = () => {
  const [userId, setUserId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleRedeem = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(`${marketingBackendUrl}/api/redeem-discount`, {
        userId,
        courseId,
        couponCode

      });

      setMessage(response.data.message || "Success!");
    } catch (error) {
      setMessage(error.response?.data?.message || "Error processing request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Redeem Discount</h2>
      <form onSubmit={handleRedeem} className={styles.form}>
        <input
          type="text"
          placeholder="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          required
          className={styles.input}
        />
        <input
          type="text"
          placeholder="Course ID"
          value={courseId}
          onChange={(e) => setCourseId(e.target.value)}
          required
          className={styles.input}
        />
        <input
          type="text"
          placeholder="Coupon Code (Optional)"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          className={styles.input}
        />
        <button
          type="submit"
          disabled={loading}
          className={`${styles.button} ${loading ? styles.disabled : ""}`}
        >
          {loading ? "Processing..." : "Redeem"}
        </button>
      </form>
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default RedeemDiscount;
